export default __webpack_public_path__ + "static/media/NR.868665b5.svg";